export default __webpack_public_path__ + "static/whatsapp-61d5f529a3303dd632479cdde514586d.png";